// ประเภทผู้อนุมัติ (ผู้บังคับบัญชาระดับ 1 / 2) ที่แต่ละประเภทผู้ใช้เลือกได้
// ต้องตรงกับ SNAPA-Backend config/user_type.js (APPROVER_TYPES_BY_USER_TYPE) - backend เป็นตัวตัดสินจริงตอนบันทึก
// ประเภทที่ไม่อยู่ในตาราง (admin ฯลฯ) ใช้ค่าเดิม = supervisor / executive
export const APPROVER_TYPES_BY_USER_TYPE = {
  technician: ["head_technician", "chief_technician", "supervisor", "executive"],
  head_technician: ["head_technician", "chief_technician", "supervisor", "executive"],
  chief_technician: ["chief_technician", "supervisor", "executive"],
  supervisor: ["supervisor", "executive"],
  // Time & Activity Only ระดับเดียวกับช่าง เลือกผู้อนุมัติได้เหมือน technician
  time_activity: ["head_technician", "chief_technician", "supervisor", "executive"],
};
export const DEFAULT_APPROVER_TYPES = ["supervisor", "executive"];

export const getApproverTypeKeys = (userType) => APPROVER_TYPES_BY_USER_TYPE[userType] || DEFAULT_APPROVER_TYPES;

// รวมทุกประเภทที่มีโอกาสเป็นผู้อนุมัติ - ใช้ดึงรายชื่อครั้งเดียวแล้วกรองตามประเภทของคนที่แก้
export const ALL_APPROVER_TYPE_KEYS = [...new Set([...Object.values(APPROVER_TYPES_BY_USER_TYPE).flat(), ...DEFAULT_APPROVER_TYPES])];

export const canApproverFor = (userType, approverType) => getApproverTypeKeys(userType).includes(approverType);
